import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { PreviewPlacement } from '../../-components/PreviewPlacement';

export const Route = createFileRoute('/_authenticated/preview/placement/$sectionId/$tenantId')({
    context: ({ params }) => ({
        sectionContentQuery: client.placement.section.getContent.queryOptions({
            params: { id: params.sectionId },
            query: { includePreviewUrl: true },
        }),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.sectionContentQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: PreviewPlacement,
});
